import {useQuery} from "react-query";
import queryKeys from "../../constants/queryKeys";
import userAutomaticEmailReplyService from "../../services/userAutomaticEmailReplyService";

const useUserAutomaticEmailReply = ({ userId }) =>
    useQuery(
        [queryKeys.userAutomaticEmailReply, userId],
        () => userAutomaticEmailReplyService.fetchForUser(userId),
        {
            enabled: !!userId,
            staleTime: 600000,
            cacheTime: 900000
        }
    );

export default useUserAutomaticEmailReply;